import{useSelector}from'react-redux';const useHeader=()=>useSelector(state=>state.header);export default useHeader;